const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileDownloadBlack24Dp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_download_black_24dp_svg__linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 147.05,
    y1: 179.64,
    x2: 283.97,
    y2: 179.64,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_download_black_24dp_svg__linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 153.04,
    y1: 179.64,
    x2: 277.98,
    y2: 179.64,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file_download_black_24dp_svg__surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 7.058594 27.617188 C 6.007812 27.617188 5.015625 27.207031 4.273438 26.460938 C 3.527344 25.71875 3.117188 24.726562 3.121094 23.671875 L 3.125 20.34375 C 3.125 19.8125 3.558594 19.378906 4.09375 19.378906 C 4.628906 19.378906 5.058594 19.8125 5.058594 20.347656 L 5.054688 23.675781 C 5.054688 24.210938 5.261719 24.714844 5.640625 25.09375 C 6.019531 25.472656 6.523438 25.683594 7.058594 25.683594 L 24.929688 25.683594 C 26.039062 25.683594 26.941406 24.78125 26.941406 23.671875 L 26.945312 20.46875 C 26.945312 19.9375 27.378906 19.503906 27.914062 19.503906 C 28.171875 19.503906 28.414062 19.605469 28.597656 19.789062 C 28.78125 19.96875 28.882812 20.210938 28.882812 20.472656 L 28.875 23.675781 C 28.875 25.847656 27.101562 27.617188 24.929688 27.617188 Z M 7.058594 27.617188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 24.929688 27.171875 L 7.058594 27.171875 C 6.125 27.171875 5.246094 26.808594 4.585938 26.148438 C 3.925781 25.484375 3.5625 24.605469 3.566406 23.675781 L 3.570312 20.34375 C 3.570312 20.058594 3.804688 19.824219 4.089844 19.824219 L 4.09375 19.824219 C 4.378906 19.824219 4.613281 20.058594 4.613281 20.347656 L 4.605469 23.675781 C 4.605469 24.332031 4.859375 24.945312 5.324219 25.410156 C 5.785156 25.875 6.402344 26.128906 7.058594 26.128906 L 24.929688 26.128906 C 26.28125 26.128906 27.386719 25.027344 27.386719 23.671875 L 27.390625 20.46875 C 27.390625 20.183594 27.625 19.949219 27.914062 19.949219 C 28.199219 19.949219 28.433594 20.183594 28.433594 20.472656 L 28.429688 23.675781 C 28.425781 25.601562 26.855469 27.171875 24.925781 27.171875 Z M 24.929688 27.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_download_black_24dp_svg__linear0)"
    },
    d: "M 16.023438 22.328125 C 15.773438 22.328125 15.539062 22.230469 15.359375 22.050781 L 11.21875 17.90625 C 10.851562 17.542969 10.851562 16.945312 11.21875 16.578125 C 11.394531 16.402344 11.632812 16.304688 11.882812 16.304688 C 12.132812 16.304688 12.367188 16.402344 12.546875 16.578125 L 15.085938 19.121094 L 15.085938 5.347656 C 15.085938 4.832031 15.507812 4.410156 16.027344 4.410156 C 16.542969 4.410156 16.964844 4.832031 16.964844 5.347656 L 16.964844 19.117188 L 19.53125 16.554688 C 19.707031 16.378906 19.941406 16.277344 20.195312 16.277344 C 20.445312 16.277344 20.679688 16.375 20.855469 16.554688 C 21.222656 16.921875 21.222656 17.515625 20.855469 17.882812 L 16.6875 22.050781 C 16.511719 22.230469 16.273438 22.328125 16.023438 22.328125 Z M 16.023438 22.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_download_black_24dp_svg__linear1)"
    },
    d: "M 16.023438 21.878906 C 15.894531 21.878906 15.769531 21.828125 15.675781 21.734375 L 11.535156 17.59375 C 11.339844 17.402344 11.339844 17.089844 11.535156 16.894531 C 11.726562 16.703125 12.039062 16.703125 12.230469 16.894531 L 15.535156 20.199219 L 15.535156 5.347656 C 15.535156 5.074219 15.753906 4.855469 16.027344 4.855469 C 16.300781 4.855469 16.519531 5.074219 16.519531 5.347656 L 16.519531 20.195312 L 19.847656 16.871094 C 20.039062 16.675781 20.351562 16.675781 20.542969 16.871094 C 20.734375 17.0625 20.734375 17.375 20.542969 17.566406 L 16.375 21.734375 C 16.28125 21.828125 16.15625 21.878906 16.023438 21.878906 Z M 16.023438 21.878906 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownloadBlack24Dp);
export default __webpack_public_path__ + "static/media/file_download_black_24dp.741d459ae823181dd28ea7397d0b8c18.svg";
export { ForwardRef as ReactComponent };